import styled from 'styled-components';
import { DEVICES } from '@thinknet-gmbh/platform-common-ui';

export const TrialPeriodWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 36px;
  & > div:first-child {
    margin-right: 4px;
  }
  @media ${DEVICES.sm} {
    margin-right: 24px;
  }
`;
